import { render, staticRenderFns } from "./CustomSelect.vue?vue&type=template&id=cd3b3dd0&scoped=true"
import script from "./CustomSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomSelect.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CustomSelect.vue?vue&type=style&index=0&id=cd3b3dd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd3b3dd0",
  null
  
)

export default component.exports